/* eslint-disable */
import React from 'react';
import { H1 } from 'components/core/Headline';

export default () => (
    <div>
        <H1>SpareFoot, Inc. Terms of Service</H1>

        <p><strong>Last Updated: February 25, 2025</strong></p>

        <p>
            These Terms of Service (this <strong>"Agreement"</strong>) explain the agreement between SpareFoot, Inc.
            (<strong>"SpareFoot"</strong>) and you, a self-storage facility owner or operator (<strong>"Client"</strong>). This Agreement is made
            to be effective as of the date you agree to receive Services (as defied herein) from SpareFoot (the
            <strong>"Effective Date"</strong>). This Agreement and your order form (if applicable) governs the terms and
            conditions pursuant to which SpareFoot will provide you with access to certain services described in
            Section 1 below (each, a <strong>"Service"</strong> and collectively, the <strong>"Services"</strong>). By your electronic
            acknowledgement of this Agreement or by your continued use of the Services, you, on behalf of
            yourself and, if applicable, your organization, accept the terms and conditions of this Agreement and
            are representing and warranting that you can legally enter into this Agreement and satisfy all of the
            requirements hereunder..
        </p>
        <p>
            In consideration of the mutual promises contained herein, the parties agree as follows:
        </p>

        <p><strong>1. Background</strong></p>
        <p>
            SpareFoot is a provider of multiple Services, including but not limited to the SpareFoot AdNetwork
            Service (<strong>"AdNetwork"</strong>), the SpareFoot SiteBuilder Service (<strong>"SiteBuilder"</strong>), and the SpareFoot
            Booking Widget (<strong>"Booking Widget"</strong>). Client desires to obtain and SpareFoot desires to provide
            Client with access to one or more of the Services pursuant to this Agreement. Service-specific terms
            and conditions (each, <strong>"Supplemental Terms"</strong>) apply to one or more of the Services based on
            Client’s activation and use of the specific Service, with SpareFoot’s permission. Supplemental Terms
            are specified in the exhibits linked hereto. Any applicable Supplemental Terms shall (together with
            this Agreement and your order form) constitute the entire agreement between Client and SpareFoot
            with respect to the specific Service. Terms capitalized in the Supplemental Terms but not defined
            therein shall have the meanings given to them in this Agreement. In the event of a conflict between
            this Agreement and any such Supplemental Terms, the Supplemental Terms shall apply, solely with
            respect to such Service. In the event of a conflict between this Agreement or the Supplemental
            Terms and your order form, your order form shall apply, solely with respect to such Service.
        </p>

        <p><strong>2. Service</strong></p>
        <p>
            2.1 <em>Provision of Services</em>.
            Subject to the terms and conditions of this Agreement, including without
            limitation payment of the applicable fees specific to a Service, SpareFoot grants Client a non-
            exclusive, non-transferable, limited right to access and use the Service(s) during the term to which
            Client has subscribed solely for its/their internal business purposes.
        </p>
        <p>
            2.2 <em>Client Assistance</em>.
            Client shall provide SpareFoot with all information and assistance as
            reasonably required for SpareFoot to activate and operate the Service(s) for Client pursuant to this
            Agreement. Client grants SpareFoot all rights or licenses necessary for SpareFoot to use such
            information in connection with the provision of the Service(s).
        </p>
        <p>
            2.3 <em>Customer Support</em>.
            SpareFoot will provide reasonable technical support services to Client for the
            services specified in the applicable Supplemental Terms.
        </p>
        <p>
            2.4 <em>Access to Service</em>.
            Client acknowledges that maintenance may be required from time to time and
            as a result the Service(s) may be offline from time to time. SpareFoot will endeavor to take steps to
            minimize disruption or limited access to the Services.
        </p>
        <p>
            2.5 <em>Customer Reviews</em>.
            In connection with the Service, client's customers may submit reviews of
            Client facilities via SpareFoot's website, by survey or otherwise. Client acknowledges SpareFoot's
            right to publish reviews concerning Client's facilities and that reviews submitted to SpareFoot and
            posted on its website reflect the opinions and beliefs of the individual reviewers and not of
            SpareFoot or any of its affiliates, officers, directors or employees. SpareFoot is not responsible and
            assumes no liability for any reviews, or for any loss or damage related to such reviews. Client shall
            not review Client facilities or any competing facilities. SpareFoot has no obligation to delete reviews
            of any facility or monitor the reviews or related responses, though it reserves the right to do so.
            Client may post one response to each customer review of its facilities, so long as the response does
            not violate SpareFoot's Review Terms and Conditions available at
            <a href="https://www.sparefoot.com/legal/reviewstoc.html">https://www.sparefoot.com/legal/reviewstoc.html</a>. SpareFoot encourages Client to respond to any
            negative reviews and identify how it intends to rectify the customers' concerns. If Client believes a
            review of a Client facility is fraudulent or in violation of SpareFoot's Review Terms and Conditions,
            Client should contact SpareFoot at <a href="mailto:support@sparefoot.com">support@sparefoot.com</a>. If after reviewing the information
            provided by Client regarding the review, SpareFoot may, but is not required to, remove the review
            from its website, subject to the other terms herein.
        </p>
        <p>
            <strong>3. Client Obligations</strong>
        </p>
        <p>
            3.1 <em>Rights Regarding Site(s)</em>.
            Client certifies that it owns or has all necessary rights to control the
            website(s), if any, that is/are integrated with or linked with the Service(s) (the <strong>"Client Site(s)"</strong>), and
            that to the extent required and applicable, Client has all rights necessary to integrate the Service(s)
            with the Client Site, to administer the Service, and to fulfill its obligations under this Agreement.
        </p>
        <p>
            3.2 <em>Bug Reporting</em>.
            Client shall promptly report to SpareFoot all bugs and errors related to the
            Service(s) of which Client becomes aware.
        </p>
        <p>
            3.3 <em>Client Responsibilities and Restrictions</em>.
            Client is responsible for all activities that occur under the
            use of the Services. Client shall (i) have sole responsibility for the accuracy, quality, integrity,
            legality, reliability, and appropriateness of all data and content submitted for use of the Services;
            (ii) use best efforts to prevent unauthorized control or tampering of any other unauthorized
            access to, or use of, the Services and notify SpareFoot promptly of any unauthorized use or
            security breach; (iii) comply with all applicable local, state, federal, and foreign laws (including
            laws regarding privacy and protection of personal or consumer information) in using the
            Services; (iv) to the extent applicable, comply with all applicable rules of credit card associations
            (including American Express, MasterCard and Visa); and (v) obtain and maintain all computer
            hardware, software and communications equipment needed to access the Services and pay all
            access charges (e.g., ISP fees) incurred by you in connection with your use of the Services.
            Client may not (i) disassemble, reverse engineer, decompile or otherwise attempt to decipher
            any code in connection with the Services, or modify, adapt, create derivate works based upon,
            or translate the Services; (ii) license, sublicense, sell, rent , assign, distribute, time share
            transfer, lease, loan, resell, distribute or otherwise commercially exploit, grant rights in or make
            the Services available to any third party; (iii) use the Services except as expressly authorized
            hereunder or in violation of any Applicable Laws; (iv) manage, create, develop, market, sell, or
            distribute or assist another party to manage, create, develop, market, sell, or distribute
            competitive Services; (v) engage in any illegal or deceptive trade practices with respect to the
            Services; (vi) circumvent or disable any security or other technical features or measures of the
            Services or any other aspect of the software or, in any manner, attempt to gain or attain
            unauthorized access to the Services or its related computer systems or networks; (vii) use the
            Services to transmit infringing, libelous, obscene, threatening, malicious code, or otherwise
            unlawful, unsafe, abusive or tortious material, or to store or transmit material in violation of third-
            party privacy rights; (viii) use the Services to store or transmit any malicious code or unsolicited
            messages in violation of applicable laws, (ix) interfere with or disrupts the integrity or
            performance of the Services or third-party data contained therein, or (x) or (x) use any robot,
            spider, other automated device or process, or manual process to (a) crawl, monitor, copy, or
            "scrape" web pages or the content contained in the Services or (b) access the Services, or
            substantially download, reproduce or archive any portion of the Services.
        </p>

        <p>
            <strong>4. Fees</strong>
        </p>
        <p>
            4.1 <em>Fees</em>.
            Client shall pay SpareFoot the fees, if any, set forth in the Supplemental Terms or Client’s
            order form accepted and agreed to by Client. All fees are non-refundable, provided that if any
            Service that is for a specified term is terminated by SpareFoot pursuant to Section 8.2.1, then
            SpareFoot shall refund a pro-rated portion of any pre-paid subscription fee.
        </p>
        <p>
            4.2 <em>Fee Increases</em>.
            Unless otherwise set forth in the Supplemental Terms, from time to time, fees
            may be increased after the initial term upon prior notice to the Client.
        </p>
        <p>
            4.3 <em>Move in Floor Charge</em>.
            Client’s will be charged an additional fee each month if Client’s Move-In
            Rate ("MIR") is less than an identified percentage (below the platform average of 50%) as
            communicated to Client. The MIR fee represents the additional move-in fees SpareFoot would have
            collected if your MIR had been at the identified percentage.
        </p>
        <p>
            4.4 <em>Invoicing</em>.
            SpareFoot may invoice Client for any applicable fees incurred by the Client from time
            to time in connection with the Service(s). Unless otherwise specified in the applicable Supplemental
            Terms or Client’s order form, all fees are due and payable in U.S. dollars within thirty (30) days of of
            the date of the SpareFoot invoice.
        </p>

        <p>
            4.5 <em>Late Payments</em>.
            If payment is not made by Client within thirty (30) days after the invoice date,
            SpareFoot may charge Client a late fee on the unpaid balance at the lesser of one-and-a-half
            percent (1.5%) per month or the maximum lawful rate permitted by applicable law, rounded to the
            next highest whole month and compounded monthly. Client agrees to pay for all costs incurred by
            SpareFoot in connection with the collection of such past due amounts, including, without limitation,
            reasonable attorneys’ and collections agencies’ fees.. Should Client not pay amounts when due,
            SpareFoot may (at its discretion and in addition to other remedies it may have) deactivate the
            Service(s) and terminate this Agreement.
        </p>
        <p>
            4.6 <em>Taxes</em>.
            Client shall be responsible for sales tax, use tax, value added taxes, withholding taxes
            and any other similar taxes and charge of any kind imposed by federal, state or local governmental
            entity on the transactions contemplated by the Agreement. When SpareFoot has the legal obligation
            to pay or collect taxes for which the Client is responsible for, pursuant to this Section 4, the
            appropriate amount shall be invoiced to and thereafter paid by Client unless Client provides
            SpareFoot with a valid tax exemption certificate authorized by the appropriate taxing authority before
            invoice is sent.
        </p>

        <p>
            <strong>5. Proprietary Rights</strong>
        </p>
        <p>
            5.1 <em>Ownership of the Service</em>.
            SpareFoot shall exclusively own all right, title, and interest in and to
            the Service, including all modifications, improvements, upgrades, and derivative works related
            thereto and all intellectual property rights therein. Client agrees to assign all right, title, and interest it
            may have in the foregoing to SpareFoot. If Client provides or creates comments, input, or feedback
            in connection with the Service(s) or pursuant to Section 3.2 hereof (<strong>"Feedback"</strong>), Client hereby
            assigns all of its right, title, and interest in and to such Feedback to SpareFoot. To the extent that the
            foregoing assignment is ineffective for whatever reason, Client hereby grants to SpareFoot a non-exclusive,
            perpetual, irrevocable, royalty free, worldwide right and license to use, reproduce,
            disclose, sub-license, distribute, modify and otherwise exploit such Feedback without restriction.
        </p>
        <p>
            5.2 <em>Trademark Restrictions</em>.
            Client shall not remove, alter, cover or obfuscate any copyright notices
            or other proprietary rights notices or proprietary mark placed or embedded by SpareFoot on or in the
            Service.
        </p>
        <p>
            5.3 <em>Data Ownership</em>.
            Client shall own all right, title, and interest in and to any data that is collected by
            SpareFoot from Client or provided by Client in connection with Client’s use of the Service (<strong>"Data"</strong>)
            and grants a non-revocable license to Sparefoot to use such Data as set forth herein. Client shall not
            include in the Data any personal, sensitive, or private data protected by customer data laws.
        </p>
        <p>
            5.4 <em>Protection of Client Data, Personal Information, and Confidential Information</em>.
            Each party is
            responsible for complying with applicable laws, including applicable data protection legal
            requirements, for the purpose of this agreement. SpareFoot shall implement and maintain
            reasonable technical, administrative, and physical safeguards and security methods designed to
            prevent any unauthorized release, access, destruction, modification, or disclosure of client data,
            confidential information or personal information. SpareFoot may occasionally update, change, or add
            safeguards and security methods as warranted in SpareFoot’s sole discretion. SpareFoot will
            provide notice if Client needs to take action to facilitate continued interaction with the Services.
            Additional Information of how we treat Client data us set forth in our privacy policy, available at
            <a href="https://www.sparefoot.com/legal/privacy.html">https://www.sparefoot.com/legal/privacy.html</a>.
        </p>
        <p>
            5.5 <em>Use of Anonymous Data</em>.
            SpareFoot, at its discretion, may distribute certain Client data to other
            sites, forums, aggregators, or other 3rd parties for the purpose of promoting Client facilities either
            individually or in aggregate, pursuant to providing the agreed Service to Client. Data that is
            published to the Internet on behalf of Client to affect the Service is considered publicly available and
            not bound by any confidentiality provisions. This includes but is not limited to facility information, unit
            pricing, unit availability, photos, consumer reviews, and consumer survey responses.
        </p>
        <p>
            5.6 <em>Integration</em>.
            Client may elect to manage the Service manually or integrate with SpareFoot via an
            existing software vendor. Software vendors supported by SpareFoot include but are not limited to
            SiteLink, storEDGE, and Easy Storage Solutions, (the <strong>"Vendor"</strong>). Specific to data available via the
            agreed Vendor, (the <strong>"Database"</strong>), Client grants to SpareFoot a non-exclusive, transferable, sub-
            licensable, world-wide license to establish a link from SpareFoot’s websites to Client’s Database
            server (the <strong>"Link"</strong>) for the term of this Agreement. In its use of the Link and in its relationship with the
            Vendor, SpareFoot acts as an agent of Client. The Link enables Client and SpareFoot to maintain
            unit pricing and availability information on SpareFoot websites and, if supported by the Vendor,
            allows SpareFoot to initiate reservations on behalf of prospective Client customers. Client shall be
            responsible for enabling the Link and obtaining all the necessary licenses, credentials, and
            authorizations from the Vendor to integrate the Database with SpareFoot’s websites and allow
            SpareFoot to access the Database on Client’s behalf. Client agrees that SpareFoot shall have the
            right, on behalf of Client, to view facility information, unit pricing and availability information, in
            addition to viewing tenant roster information pursuant to verifying move-ins. SpareFoot has the right
            to copy unit pricing and inventory information to SpareFoot systems as needed to efficiently provide
            the Service, but will not store tenant roster information other than to record and reconcile the fact
            that a specific reservation was consummated. Database information shall remain the sole and
            exclusive property of Client and/or the Vendor, as applicable.
        </p>
        <p>
            <strong>6. Confidentiality</strong>
        </p>
        <p>
            6.1 <em>Definition of Confidential Information</em>.
            All information disclosed by a party ("Disclosing Party") to
            the other party ("Receiving Party"), whether orally or in writing, that is designated as confidential or
            that reasonably should be understood to be confidential given the nature of the information and the
            circumstances of disclosure. Client’s Confidential Information includes its/their non-public Data;
            SpareFoot’s Confidential Information includes the Services its content; and Confidential Information
            of each party includes the terms and conditions of all order forms (including pricing), as well as
            business and marketing plans, technology and technical information, product plans and designs, and
            business processes disclosed by such party. However, Confidential Information does not include any
            information that (i) is or becomes generally known to the public without breach of any obligation
            owed to the Disclosing Party, (ii) was known to the Receiving Party prior to its disclosure by the
            Disclosing Party without breach of any obligation owed to the Disclosing Party, (iii) is received from a
            third party without breach of any obligation owed to the Disclosing Party, or (iv) was independently
            developed by the Receiving Party.
        </p>
        <p>
            6.2 <em>Protection of Confidential Information</em>.
            The Receiving Party will use the same degree of care that
            it uses to protect the confidentiality of its own confidential information of like kind (but not less than
            reasonable care) (i) not to use any Confidential Information of the Disclosing Party for any purpose
            outside the scope of this Agreement, and (ii) except as otherwise authorized by the Disclosing Party
            in writing, to limit access to Confidential Information of the Disclosing Party to those of its and its
            Affiliates’ employees and contractors who need that access for purposes consistent with this
            Agreement. Neither party will disclose the terms any Order Form to any third party other than its
            Affiliates, legal counsel and accountants without the other party’s prior written consent, provided that
            a party that makes any such disclosure to its Affiliate, legal counsel or accountants will remain
            responsible for such Affiliate’s, legal counsel’s or accountant’s compliance with this Section 6.2.
        </p>
        <p>
            6.3 <em>Disclosures Required by Law</em>.
            The Receiving Party may disclose Confidential Information of the
            Disclosing Party to the extent compelled by law to do so, provided the Receiving Party gives the
            Disclosing Party prior notice of the compelled disclosure (to the extent legally permitted) and
            reasonable assistance, at the Disclosing Party’s cost, if the Disclosing Party wishes to contest the
            disclosure. If the Receiving Party is compelled by law to disclose the Disclosing Party’s Confidential
            Information as part of a civil proceeding to which the Disclosing Party is a party, and the Disclosing
            Party is not contesting the disclosure, the Disclosing Party will reimburse the Receiving Party for its
            reasonable cost of compiling and providing secure access to that Confidential Information.
        </p>

        <p>
            <strong>7. Warranty and Limitations of Liability and Indemnification</strong>
        </p>
        <p>
            7.1 <em>Warranty Disclaimer</em>.
            SERVICE(S) ARE PROVIDED TO CLIENT ON AN "<strong>AS IS</strong>" AND "<strong>AS AVAILABLE</strong>"
            BASIS, AND SPAREFOOT DISCLAIMS ALL WARRANTIES, CONDITIONS, OR
            REPRESENTATIONS (EXPRESS OR IMPLIED, ORAL, OR WRITTEN) WITH RESPECT
            THERETO AND WITH RESPECT TO ANY SUPPORT RELATED THERETO, INCLUDING ANY
            AND ALL WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
            UPTIME, NON-INFRINGEMENT, NON-INTERFERENCE, ACCURACY OF DATA, AND
            WARRANTIES ARISING FROM A COURSE OF DEALING.
        </p>
        <p>
            7.2 <em>Disclaimer of Consequential Damages</em>.
            YOU ACKNOWLEDGE THAT WE HAVE HAS NOT
            PRICED THE SERVICES TO CONTEMPLATE THE RISKS OF RELIANCE BY YOU ON THE
            SERVICES TO HAVE OR ASSUME SUBSTANTIAL LIABILITY OR RESPONSIBILITY FOR YOUR
            USE THEREOF. IN NO EVENT WILL SPAREFOOT BE LIABLE TO USER FOR ANY SPECIAL,
            CONSEQUENTIAL, INCIDENTAL OR OTHER DAMAGES, HOWEVER CAUSED AND ON ANY
            THEORY OF LIABILITY, AND WHETHER OR NOT SPAREFOOT HAS BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGE.
        </p>
        <p>
            7.3 <em>Maximum Liability</em>.
            YOU ACKNOWLEDGE THAT WE HAVE HAS NOT PRICED THE
            SERVICES TO CONTEMPLATE THE RISKS OF RELIANCE BY YOU ON THE SERVICES TO
            HAVE OR ASSUME SUBSTANTIAL LIABILITY OR RESPONSIBILITY FOR YOUR USE THEREOF.
            IN NO EVENT SHALL SPAREFOOT’S AGGREGATE LIABILITY ARISING OUT OF OR RELATED
            TO THIS AGREEMENT, THE TERMINATION HEREOF, AND/OR PROVISION OF THE SERVICE
            EXCEED THE AMOUNTS PAID BY CLIENT TO SPAREFOOT FOR THE SPECIFIC SERVICE
            GIVING RISE TO THE CLAIM DURING THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
            THIS LIMITATION OF LIABILITY IS CUMULATIVE AND NOT PER INCIDENT.
        </p>
        <p>
            7.4 <em>Reasonable Allocation of Risk.</em>
            The parties understand and agree that the limitations of liability
            set forth in this Section are a reasonable allocation of risk between the parties, and, absent such
            allocation, SpareFoot would not be able to charge the prices it is charges for the Service. The
            limitations of liability set forth in this Agreement shall apply notwithstanding any failure of essential
            purpose of any limited remedy provided herein.
        </p>
        <p>
            7.5 <em>Indemnification.</em>
            Client agrees to indemnify, hold harmless, and defend SpareFoot and its
            employees, officers, directors and agents from any and all claims, demands, suits, proceedings,
            investigations, damages, costs, expenses, losses, and any other liabilities (including reasonable
            attorneys’ fees, court costs and expenses) ("Claims") arising out of or relating to (i) Client’s use of
            the Services, (ii) any content provided by Client, (iii) any actual or alleged breach by Client of any
            representation, warranty, covenant or obligation under the Agreement, or (iv) gross negligence or
            willful misconduct.
        </p>
        <p>
            <strong>8. Term of Agreement</strong>
        </p>
        <p>
            8.1 <em>Term</em>.
            This Agreement will commence on the Effective Date and will continue for until terminated
            in accordance herewith. Any term specified on any Supplemental Terms shall, unless a party notifies
            the other in writing not less than sixty (60) days prior to the end of the then current applicable term,
            automatically renew for successive terms.
        </p>
        <p>
            8.1.1 <em>Automatic Renewal</em>.
            At the end of the term specified on any Supplemental Terms or order
            form, the Service will automatically renew for additional one-month periods unless Client provides
            written notice of non-renewal to SpareFoot at least thirty (30) days prior to the end of the term
            expiration date. Client must submit notice of non-renewal to Sparefoot in accordance with the
            provisions as outlined in Section 8.3.
        </p>
        <p>
            8.2 <em>Termination</em>.
        </p>
        <p>
            8.2.1 <em>Convenience</em>.
            Unless agreed to in an order form or otherwise, Client or SpareFoot may
            terminate this Agreement and/or any order form at any time, for any reason, effective immediately
            upon providing thirty (30) days’ notice to the other party.
        </p>
        <p>
            8.2.2 <em>For Breach</em>.
            In addition, SpareFoot may terminate this Agreement and/or any Supplemental
            Terms if Client is in breach of any term or condition set forth herein or therein, and such breach is
            not cured in the ten (10) day period following SpareFoot giving notice of such breach.
        </p>
        <p>
            8.2.3 <em>Effect of Termination</em>.
            Upon termination of this Agreement and/or any Order Form, Client
            agrees to immediately discontinue use of the applicable Services, cease to represent in any form to
            be a user of the terminated Services, and destroy all Confidential Information. Neither party shall be
            liable for any damages resulting from a termination of the Agreement or Supplemental Terms as
            provided for herein; provided, however, that the termination of the Agreement does not affect any
            claim arising prior to such termination.
        </p>
        <p>
            8.2.4 <em>Your Data in the Event of Termination</em>.
            Client acknowledges and agrees that following
            expiration or termination of Services or Supplemental Terms in whole or in part, SpareFoot may
            immediately deactivate all affected and related Services and shall have no obligation to continue to
            store Data during any period of suspension or termination or to permit Client to retrieve such data.
        </p>
        <p>
            Client further agrees that SpareFoot shall not be liable to Client or to any third party for any
            termination of access to the Services or deletion of data pursuant to this Agreement. Following the
            termination of Client’s right to use the Services for any reason other than termination for cause by
            SpareFoot, Client may use any post-termination assistance we may generally make available with
            respect to the Services. SpareFoot may also endeavor to provide Client with unique post-suspension
            or post-termination assistance, but shall be under no obligation to do so.
        </p>
        <p>
            8.2.5 <em>Exemption from Return of Data</em>.
            Notwithstanding anything to the contrary in this Section 8.2
            (Termination) SpareFoot shall not be required to return to Client or destroy those copies of the Client
            Data or confidential information which copies were created pursuant to SpareFoot’s automatic
            archiving and backup procedures and the removal of which is not technically reasonable.
        </p>
        <p>
            8.3 <em>Survival of Certain Terms</em>.
            Notwithstanding any termination of this Agreement, the following
            provisions shall survive: Sections 4-7, 8.3, and 9, and any Supplemental Terms identified as
            provisions that shall survive the termination hereof. All other rights, obligations, and licenses set forth
            herein shall cease upon termination of this Agreement for any reason.
        </p>
        <p>
            <strong>9. General Provisions</strong>
        </p>
        <p>
            9.1 <em>Compliance with Laws</em>.
            Client shall comply with all applicable laws, rules, treaties, and
            regulations in its performance of this Agreement. Client shall hold harmless and defend SpareFoot
            from any claim, action, suit or demand against SpareFoot arising from Client’s failure to comply with
            this paragraph and shall indemnify SpareFoot for any and all damages, liabilities, costs and
            expenses related thereto.
        </p>
        <p>
            9.2 <em>Governing Law and Jurisdiction</em>.
            This Agreement shall be governed by and construed under the
            law of the State of Texas, without regard to principles of conflict of laws.
        </p>
        <p>
            ALL CLAIMS (AS DEFINED IN ABOVE) SHALL BE RESOLVED BY BINDING ARBITRATION
            RATHER THAN IN COURT, EXCEPT THAT YOU MAY ASSERT CLAIMS IN SMALL CLAIMS
            COURT (DEFINED FOR THE PURPOSES OF THESE TERMS AS A COURT OF LIMITED
            JURISDICTION THAT MAY ONLY HEAR CLAIMS NOT EXCEEDING $5,000) IF YOUR CLAIMS
            ARE WITHIN THE COURT’S ORIGINAL JURISDICTION. THERE IS NO JUDGE OR JURY IN
            ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED.
        </p>
        <p>
            The arbitration shall be conducted by the American Arbitration Association (AAA) under its then-
            applicable Commercial Arbitration Rules or, as appropriate, its Consumer Arbitration Rules. The
            AAA’s rules are available at <a href="http://www.adr.org/">http://www.adr.org/</a>. The arbitrator will, among other things, have the
            power to rule on his or her own jurisdiction, including any objections with respect to the existence,
            scope, or validity of the arbitration agreement or to the arbitrability of any Claims. Payment of all
            filing, administration and arbitrator fees shall be governed by the AAA’s rules. The arbitration shall
            be conducted in the English language by a single independent and neutral arbitrator. For any
            hearing conducted in person as part of the arbitration, you agree that such hearing shall be
            conducted in Austin, Texas or, if the Consumer Arbitration Rules apply, another location reasonably
            convenient to both parties with due consideration of their ability to travel and other pertinent
            circumstances, as determined by the arbitrator. The decision of the arbitrator on all matters relating
            to the Claim shall be final and binding. Judgment on the arbitral award may be entered in any court
            of competent jurisdiction.
        </p>
        <p>
            WE EACH AGREE THAT ALL CLAIMS (AS DEFINED ABOVE) SHALL BE RESOLVED ONLY ON
            AN INDIVIDUAL BASIS AND NOT IN A CLASS, COLLECTIVE, CONSOLIDATED OR
            REPRESENTATIVE ACTION, ARBITRATION OR OTHER SIMILAR PROCESS AND EXPRESSLY
            WAIVE ANY RIGHT TO HAVE A CLAIM DETERMINED OR RESOLVED ON A CLASS,
            COLLECTIVE, CONSOLIDATED OR REPRESENTATIVE BASIS. IF FOR ANY REASON THE
            PROVISIONS OF THE PRECEDING SENTENCE ARE HELD TO BE INVALID OR
            UNENFORCEABLE IN A CASE IN WHICH CLASS, COLLECTIVE, CONSOLIDATED OR
            REPRESENTATIVE CLAIMS HAVE BEEN ASSERTED, THE PROVISIONS OF THIS SECTION 19
            REQUIRING BINDING ARBITRATION SHALL LIKEWISE BE UNENFORCEABLE AND NULL AND
            VOID. IF FOR ANY REASON A CLAIM PROCEEDS IN COURT RATHER THAN IN ARBITRATION,
            THE PARTIES EACH WAIVE ANY RIGHT TO A JURY TRIAL AND AGREE THAT SUCH CLAIM
            SHALL BE BROUGHT ONLY IN A COURT OF COMPETENT JURISDICTION IN AUSTIN, TEXAS.
            YOU HEREBY SUBMIT TO THE PERSONAL JURISDICTION AND VENUE OF SUCH COURTS
            AND WAIVE ANY OBJECTION ON THE GROUNDS OF VENUE, FORUM NON-CONVENIENS OR
            ANY SIMILAR GROUNDS WITH RESPECT TO ANY SUCH CLAIM.
        </p>
        <p>
            9.3 <em>Notices</em>.
            Unless otherwise specified, any notice required or permitted by this Agreement will be in writing and will be sent by
            registered or certified mail or email at (i) the address shown at the beginning of this Agreement (in
            the case of SpareFoot), (ii) the address or email address provided to SpareFoot in connection with
            Client’s registration for the Service(s), (in the case of Client), or (iii) such other address for which
            such party gives notice hereunder. Such notice will be deemed to have been given when delivered
            or, if delivery is not accomplished by some fault of the addressee, when tendered.
        </p>
        <p>
            9.4 <em>Entire Agreement</em>.
            This Agreement and any applicable Supplemental Terms set forth the entire
            agreement and understanding of the parties relating to the subject matter hereof and thereof.
        </p>
        <p>
            9.5 <em>Modification</em>.
            SpareFoot may modify any of the terms and conditions contained in this Agreement
            and/or any Supplemental Terms, at any time in our sole discretion. Notification to Client of any
            change by e-mail or posting of a change notice on SpareFoot's website, at SpareFoot’s sole option,
            at least fifteen (15) days prior to effecting such change, will be considered sufficient notice to Client
            of a modification to the terms and conditions of this Agreement and/or any Supplemental Terms, as
            applicable. Modifications may include, without limitation, changes in the amount and/or types of fees
            payable to SpareFoot. IF ANY MODIFICATION IS UNACCEPTABLE TO CLIENT, CLIENT’S SOLE
            RECOURSE IS TO TERMINATE THIS AGREEMENT AND/OR ANY APPLICABLE ORDER FORM.
            CLIENT’S CONTINUED USE OF THE SERVICES FOLLOWING SPAREFOOT’S POSTING OF A
            CHANGE NOTICE OR NEW AGREEMENT ON SPAREFOOT’S WEBSITE CONSTITUTES
            BINDING ACCEPTANCE OF THE CHANGE BY CLIENT.
        </p>
        <p>
            Any modification of or amendment to this Agreement and/or any Supplemental Terms by Client , will
            be effective only if set forth in writing and signed physically or electronically by authorized employees
            of both parties.
        </p>
        <p>
            9.6 <em>Severability</em>.
            If any provision of this Agreement is held to be invalid by a court of competent
            jurisdiction, then the remaining provisions will nevertheless remain in full force and effect.
        </p>
        <p>
            9.7 <em>No Waiver</em>.
            The failure of either party to enforce at any time any of the provisions of the
            Agreement, or the failure to require at any time performance by the other party of any of the
            provisions of this Agreement, will in no way be construed to be a present or future waiver of such
            provisions.
        </p>
        <p>
            9.8 <em>Force Majeure</em>.
            Nonperformance of either party (except for payment obligations) will be excused
            to the extent that performance is rendered impossible by strike, fire, flood, lightening, governmental
            acts or orders or restrictions, failure of suppliers, or any other reason where failure to perform is
            beyond the reasonable control and not caused by the negligence of the non-performing party.
        </p>
        <p>
            9.9 <em>Assignment and Binding Effect</em>.
            SpareFoot may transfer or assign this Agreement and its rights
            and/or obligations hereunder. Client may transfer or assign its rights or obligations under this
            Agreement on providing written notice to SpareFoot, subject to SpareFoot’s right to terminate as
            described in Section 8.2.
        </p>
        <p>
            9.10 <em> Injunctive Relief</em>.
            Client agrees that any breach of its obligations regarding Confidential
            Information would result in irreparable injury for which there is no adequate remedy at law.
            Therefore, in the event of any breach or threatened breach of Client’s obligations regarding
            Confidential Information, SpareFoot will be entitled to obtain equitable relief in addition to its other
            available legal remedies in a court of competent jurisdiction, without the necessity of proving actual
            damages or posting bond.
        </p>
        <p>
            <strong>Exhibit A: SpareFoot AdNetwork Supplemental Terms</strong>
        </p>
        <p>
            <strong>A1. Effectiveness of Terms</strong>
        </p>
        <p>
            These Supplemental Terms (<strong>"Supplemental Terms"</strong>), together with the SpareFoot Client Terms of
            Service, explain the contractual agreement between SpareFoot and Client with respect to Client’s
            procurement of the SpareFoot AdNetwork Service. These Supplemental Terms are effective as of
            the date of AdNetwork Service activation by SpareFoot, based on Client request. SpareFoot
            reserves the right to deny activation of the Service at its sole discretion.
        </p>
        <p>
            <strong>A2. Service</strong>
        </p>
        <ol>
            <li>
                SpareFoot will make vacant units at Client’s facilities visible on the SpareFoot AdNetwork.
            </li>
            <li>
                SpareFoot will allow consumers to reserve units in Client’s facilities via the SpareFoot
                AdNetwork, online and by phone.
            </li>
            <li>
                SpareFoot will allow Client to maintain information about its facilities via my.sparefoot.com
                (<strong>"Client Portal"</strong>).
            </li>
            <li>
                SpareFoot will obtain vacant inventory information from Client’s storage management
                software provider, or if no software integration is available Client will provide and maintain
                their inventory information via the my.sparefoot.com website.
            </li>
        </ol>
        <p>
            <strong>A3. Pricing and Payment Terms</strong>
        </p>
        <table width="100%" cellPadding="2" cellSpacing="0">
            <tbody>
                <tr>
                    <td width="14%">
                        Setup Fee
                    </td>
                    <td width="86%">
                        No fee
                    </td>
                </tr>
                <tr>
                    <td width="14%">
                        Transaction Fee (CPA)
                    </td>
                    <td width="86%">
                        Client shall pay SpareFoot a Transaction Fee per move-in processed for each
                        unit in a facility equal to the price applicable to the unit at the time of reservation,
                        irrespective of any promotions, discounts, or incentives offered to consumers,
                        multiplied by the unit price multiplier (<strong>"Bid Modifier"</strong>) Client bid on such facility
                        through the Client Portal. SpareFoot may, in its sole discretion, at any time, set
                        minimum and/or maximum unit price multipliers that Client may bid as a Bid
                        Modifier for each facility. In particular, if your facility is not integrated with a
                        Vendor as set forth in Section 5.6, your Transaction Fee is subject to a Move-in
                        Rate Floor or a Required Move-in Rate as communicated to you, as applicable.
                    </td>
                </tr>
                <tr>
                    <td width="14%">
                        Subscription Fee
                    </td>
                    <td width="86%">
                        $50 per month, invoiced monthly by SpareFoot, in advance
                    </td>
                </tr>
            </tbody>
        </table>
        <p>
            Billing Statement, Reconciliation and Payment. On or about the first day of each month, SpareFoot
            will generate and issue a statement (the <strong>"AdNetwork Fee Statement"</strong>) which shall specify the
            aggregate fees due for such month. Client agrees and acknowledges that SpareFoot may use Client
            Data in accordance with Section 5.3 for the purpose of identifying Transaction Fees. Client shall
            have ten (10) days after the date of issuance to review, edit and reconcile the AdNetwork Fee
            Statement based on Client's own Tenant records and shall provide substantiation for any reduction
            in the amount specified in the issued AdNetwork Fee Statement upon request. The total amount due
            for each month shall be locked in at 11:59 PM central time on the 10th of the month, irrespective of
            whether Client has made edits to the AdNetwork Fee Statement. The applicable amount is payable
            on the eleventh (11th) day of the applicable month, unless delayed at SpareFoot's discretion, and
            shall be paid in accordance with Section 4.
        </p>
        <p>
            Change to Pricing Model. Client's election to change the pricing model for a particular Facility after
            the Client activates the AdNetwork Service shall be deemed a voluntary deactivation and shall be
            dealt with as set forth in Section A.4. below.
        </p>
        <p>
            <strong>A4. Service Deactivation</strong>
        </p>
        <p>
            SpareFoot reserves the right to deactivate the AdNetwork Service without notice based on Late
            Payment, as described in Section 4.4 of the SpareFoot Client Terms of Service, or if it believes that
            Client is in violation of the Agreement or the AdNetwork Supplemental Terms. Client can voluntarily
            deactivate the AdNetwork Service without terminating the Agreement by written request
            to <a href="mailto:support@sparefoot.com">support@sparefoot.com</a>, allowing 30 days for the removal of information from the SpareFoot
            AdNetwork. On request for deactivation, the AdNetwork Supplemental Terms will cease to be in
            effect, although Client will still be liable for any amounts due to SpareFoot incurred during the
            effective period.
        </p>
        <p>
            <strong>
                A5. Client Obligations
            </strong>
        </p>
        <p>
            Client shall not subvert the AdNetwork reservation system by publishing direct contact information
            on the AdNetwork, or use the AdNetwork in any way that encourages consumers to reserve Client
            storage units outside of the AdNetwork system. This includes but is not limited to publishing facility
            phone numbers, email addresses, or website addresses in Client facility descriptions, promotions, or
            photos.
        </p>
        <p>
            <strong>
                Exhibit B: SpareFoot SiteBuilder Supplemental Terms
            </strong>
        </p>
        <p>
            <strong>
                B1. Effectiveness of Terms
            </strong>
        </p>
        <p>
            These Supplemental Terms (<strong>"Supplemental Terms"</strong>), together with the SpareFoot Client Terms of
            Service, explain the contractual agreement between SpareFoot and Client with respect to Client’s
            procurement of the SpareFoot SiteBuilder Service. These Supplemental Terms are effective as of
            the date of SiteBuilder Service activation by SpareFoot, based on Client request. SpareFoot
            reserves the right to deny activation of the Service at its sole discretion.
        </p>
        <p>
            <strong>
                B2. Service
            </strong>
        </p>
        <ol>
            <li>
                SpareFoot will build and host a dedicated website for Client’s storage facilities.
            </li>
            <li>
                SpareFoot will allow consumers to reserve units in Client’s facilities via the dedicated
                website.
            </li>
            <li>SpareFoot will allow Client to maintain website content via the my.sparefoot.com website.</li>
            <li>
                SpareFoot will obtain vacant inventory information from Client’s storage management
                software provider, or if no software integration is available Client can provide and maintain
                their inventory information via the my.sparefoot.com website.
            </li>
        </ol>
        <p>
            <strong>B3. Pricing and Payment Terms</strong>
        </p>
        <table width="100%" cellPadding="2" cellSpacing="0">
            <tbody>
                <tr>
                    <td width="14%">
                        Implementation Fee
                    </td>
                    <td width="86%">
                        No fee
                    </td>
                </tr>
                <tr>
                    <td width="14%">
                        Transaction Fee
                    </td>
                    <td width="86%">
                        No fee for reservations or move-ins processed
                    </td>
                </tr>
                <tr>
                    <td width="14%">
                        Subscription Fee
                    </td>
                    <td width="86%">
                        An amount, per month per storage facility, invoiced monthly by SpareFoot, in
                        advance as set forth on your order form.
                    </td>
                </tr>
                <tr>
                    <td width="14%">
                        Fee Waivers
                    </td>
                    <td width="86%">
                        First 30 days after service activation is free (Client not billed for this period)
                    </td>
                </tr>
            </tbody>
        </table>
        <p>
            <strong>
                B4. Service Deactivation
            </strong>
        </p>
        <p>
            SpareFoot reserves the right to deactivate the SiteBuilder Service without notice based on Late
            Payment, as described in Section 4.4 of the SpareFoot Client Terms of Service, or if it believes that
            Client is in violation of the Agreement or the SiteBuilder Supplemental Terms. Client can voluntarily
            deactivate the SiteBuilder Service without terminating the Agreement by written request
            to <a href="mailto:support@sparefoot.com">support@sparefoot.com</a>, allowing 30 days for the hosted site to be removed. On request for
            deactivation, SiteBuilder Supplemental Terms will cease to be in effect, although Client will still be
            liable for any amounts due to SpareFoot incurred during the effective period.
        </p>
        <p>
            <strong>
                Exhibit C: SpareFoot Insights Supplemental Terms
            </strong>
        </p>
        <p>
            <strong>
                C1. Effectiveness of Terms
            </strong>
        </p>
        <p>
            These Supplemental Terms (<strong>"Supplemental Terms"</strong>), together with the SpareFoot Client Terms of
            Service, explain the contractual agreement between SpareFoot and Client with respect to Client’s
            procurement of the SpareFoot Insights Service. These Supplemental Terms are effective as of the
            date of Insights Service activation by SpareFoot, based on Client request. SpareFoot reserves the
            right to deny activation of the Service at its sole discretion, refunding any advance payment for the
            Service, if applicable.
        </p>
        <p>
            <strong>
                C2. Service
            </strong>
        </p>
        <ol>
            <li>
                SpareFoot will make available to client via my.sparefoot.com reports on average regional self
                storage pricing specific to each of Client’s facilities where service is activated.
            </li>
            <li>
                SpareFoot will allow client to access, view, and download reports for the duration of service
                activation.
            </li>
            <li>
                SpareFoot reports will consist of historical monthly data accumulated for the duration of
                service activation.
            </li>
        </ol>
        <p>
            <strong>
                C3. Pricing and Payment Terms
            </strong>
        </p>
        <table width="100%" cellPadding="2" cellSpacing="0">
            <tbody>
                <tr>
                    <td width="14%">
                        Setup Fee
                    </td>
                    <td width="86%">
                        No Fee
                    </td>
                </tr>
                <tr>
                    <td width="14%">
                        Subscription Fee
                    </td>
                    <td width="86%">
                        An amount, per month per storage facility, invoiced monthly by SpareFoot, in
                        advance as set forth on your order form.
                    </td>
                </tr>
                <tr>
                    <td width="14%">Fee Waivers</td>
                    <td width="86%">
                        Provided with a per facility subscription to AdNetwork
                    </td>
                </tr>
            </tbody>
        </table>
        <p>
            <strong>
                C4. Service Deactivation
            </strong>
        </p>
        <p>
            SpareFoot reserves the right to deactivate the Insights Service without notice based on Late
            Payment, as described in Section 4.4 of the SpareFoot Client Terms of Service, or if it believes that
            Client is in violation of the Agreement or the Insights Supplemental Terms. Client can voluntarily
            deactivate the Insights Service without terminating the Agreement by written request
            to <a href="mailto:support@sparefoot.com">support@sparefoot.com</a>. Deactivation will occur at the end of the calendar month when notice is
            received. On deactivation of the Service, the Insights Supplemental Terms will cease to be in effect,
            although Client will still be liable for any amounts due to SpareFoot incurred during the effective
            period.
        </p>
        <p>
            <strong>
                C5. Data Warranty
            </strong>
        </p>
        <p>
            Data reports are provided as-is, and SpareFoot does not warrant accuracy or suitability for any
            specific purpose.
        </p>
    </div>
);
